import React from 'react';
import messages from '../../../locale/messages';
import DashboardLayout from '../../../components/Shop/StoreLayout/Layout/DashboardLayout';
import AdditionalFeesContainer from '../additionalFees/AdditionalFeesContainer';
import StoreReviews from './storeReviews';


function action({ store, intl }) {
    const title = intl.formatMessage(messages.reviewsManagement);

    let isStoreAuthenticated = store.getState().runtime.isStoreAuthenticated;

    if (!isStoreAuthenticated) {
        return { redirect: '/store/login' };
    };

    return { 
        title,
        component: (
            <DashboardLayout>
                <StoreReviews title={title} />
            </DashboardLayout>
        )
    }
}

export default action;
